import { FC, useMemo } from 'react'
import styles from 'components/features/pfm/LinkedAccountsPage/LinkedAccountsPage.styl'
import InternalLayoutContainer from 'components/features/pfm/InternalLayout/InternalLayoutContainer'
import InternalSidebarContainer from 'components/features/pfm/InternalSidebar/InternalSidebarContainer'
import { SingleColumnLayout } from 'components/layouts/Layouts'
import { NotificationTrayWrapper } from 'components/features/pfm/NotificationTray/NotificationTrayWrapper'
import { LinkedAccounts } from 'components/features/pfm/LinkedAccounts/LinkedAccounts'
import { PageHeading } from 'components/atoms/Text'
import Button from 'components/features/pfm/Button/Button'
import Anchor from 'components/atoms/navigation/Anchor'
import MixedAccountConfirmModalContainer from 'components/features/pfm/ConfirmModal/MixedAccountConfirmModalContainer'
import { InternalPageRedirect } from 'components/features/pfm/InternalPageRedirect/InternalPageRedirect'
import { LinkAccountHandler } from 'components/features/pfm/LinkAccountHandler/LinkAccountHandler'
import { CLOSE_PANE_BUTTON_ID } from 'components/features/pfm/FloatingPaneLayout/FloatingPaneLayout'

type LinkedAccountsPageProps = {

}

function inIframe () {
  try {
    return window.self !== window.top
  } catch (e) {
    return true
  }
}

export const LinkedAccountsPage: FC<LinkedAccountsPageProps> = () => {

  // Edge case function for Fastlink iFrame linkage.
  // On successfull linkage, backend redirects to linkedaccounts so if this page
  // renders recursively in an inframe pane. Trigger it to close the pane and remove the iframe.
  const fastlinkFrame = window.parent.document.getElementById('fastlinkFrame')
  if (inIframe() && fastlinkFrame) {
    const parentNode = fastlinkFrame.parentNode
    const closeButton = window.parent.document.getElementById(CLOSE_PANE_BUTTON_ID)
    !!parentNode && parentNode.removeChild(fastlinkFrame)
    !!closeButton && closeButton.click()
  }

  const notificationsChild = useMemo(() => (
    <NotificationTrayWrapper
      renderLevel='page'
      isPositionRelative
    />
  ), [])

  return (
    <InternalPageRedirect>
      <InternalLayoutContainer
        sidebar={ <InternalSidebarContainer /> }
        notifications={ notificationsChild }
      >
        <Anchor placement='linkedaccounts'>
          <SingleColumnLayout>
            <div className={ styles.header }>
              <PageHeading className={ styles.pageTitle }>Your Linked Accounts</PageHeading>
              <LinkAccountHandler>
                <div className={ styles.pageAction }>
                  <Button size='small' iconSlug='plus' theme='blue' text='Add Account' fullWidth />
                </div>
              </LinkAccountHandler>
            </div>
            <MixedAccountConfirmModalContainer />

            <LinkedAccounts />
          </SingleColumnLayout>
        </Anchor>
      </InternalLayoutContainer>
    </InternalPageRedirect>
  )
}
